
async function getBnbBalance(account,list) {
  const ethObject = BNB;
  if (this.showBnb) {
    if (account) {
      const bnbBalance = await simpleRpcProvider.eth.getBalance(account);
      ethObject.balance = formatAmount(bnbBalance);
    }
    return [ethObject, ...list];
  }
  return list;
}

async function getTokensBalance(account,list) {
  if (account) {
    const p = list.map(item => {
      const erc20Contract = getErc20Contract(item.address);
      return erc20Contract.methods.balanceOf(account).call();
    });
    const balances = await Promise.all(p);

    return list.map((item, index) => {
      return { ...item, balance: formatAmount(balances[index], item.decimals) };
    });
  }

  return list.map(item => {
    return { ...item, balance: '' };
  });
}

export default {getBnbBalance,getTokensBalance}


